import { RadioGroupRoot } from './styles';
import { getBaseCustomProps } from '../../Utilities/types/SharedProps';
import { RadioGroupProps } from '.';
import * as meta from '../../meta-data.json';

export const radiogroupOverrides = (props: RadioGroupProps) => {
	const {
		overrides,
		children,
		disabled,
		required,
		isError,
		error,
		autoFocus,
		labelPlacement,
		onChange,
		onMouseEnter,
		onMouseLeave,
		onFocus,
		onBlur,
		...rest
	} = props;
	return {
		RadioGroupRoot: {
			style: RadioGroupRoot(props),
			props: {
				...getBaseCustomProps(props),
				...rest,
				'data-epo': `epo-radio-group-${meta.version}`,
				part: `epo-radio-group-${meta.version}`,
			},
		},
	};
};
